<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-commission-item-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Commission Item
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div v-else class="modal-body">
            <TextFormGroup
                v-model="data.value"
                name="value"
                label="Value"
                :error="getError('value')"
            />

            <DateFormGroup
                v-model="data.month"
                name="month"
                label="Month"
                help-text="The month the commission should be added."
                :error="getError('month')"
                format="MM.YYYY"
                :parameters="dateParameters"
            />

            <TextFormGroup
                v-model="data.commission_description"
                name="commission_description"
                label="Commission Description"
                :error="getError('commission_description')"
            />

            <TypeaheadFormGroup
                v-model="data.company_id"
                name="company_id"
                label="Company"
                :error="getError('company_id')"
                endpoint="/api/v2/companies"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.name"
            />

            <SelectFormGroup
                v-model="data.portal_id"
                name="portal_id"
                label="Portal"
                :options="portalOptions"
                :error="getError('portal_id')"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {LoadingSpinner, DateFormGroup, SelectFormGroup, TextFormGroup, TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    user: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {
        month: moment().add(1, 'month').startOf('month').format('YYYY-MM-DD')
      },

      portals: null,

      loading: true,
      shared: store
    }
  },

  mounted() {
    this.listenForClose()

    http.get('/api/v2/portals')
        .then(response => {
          this.portals = response.data.data

          this.loading = false
        })
  },

  computed: {
    portalOptions() {
      return this.portals.map(portal => {
        return {
          value: portal.id,
          label: portal.attributes.name
        }
      })
    },

    dateParameters() {
      return {minDate: moment().add(1, 'month').startOf('month')}
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/commission-items', {
        ...this.data,
        user_id: this.user.id
      })
          .then(response => {
            notify.success('The commission item was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
